export default __webpack_public_path__ + "static/media/shape-oblong.9124c2f0.PNG";